import type { DeviceConfiguration, PageableContent, Sort, UpdateDeviceConfiguration } from '@cobliteam/common-types';
import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import { toDeviceConfiguration, toDeviceConfigurationPage, toRequestDeviceConfiguration } from './DeviceConfigurationTransformer';

export class DeviceConfigurationRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getDevicesConfiguration = (page?: number, size?: number, sort?: Sort, deviceIds?: string[]): Promise<PageableContent<DeviceConfiguration>> => {
    const sortString = sort && Object.values(sort).join();
    const deviceIdsString = deviceIds?.join();

    const queryParams = { page, size, sort: sortString, deviceIds: deviceIdsString };
    const filteredParams = Object.fromEntries(
      Object.entries(queryParams)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    );
    const queryString = new URLSearchParams(filteredParams).toString();

    const requestData: IRequest = {
      endpoint: `/betoneira-configuration/configuration?${queryString}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => toDeviceConfigurationPage(response.data));
  };

  public postDevicesConfiguration = (devicesConfiguration: UpdateDeviceConfiguration[]): Promise<UpdateDeviceConfiguration[]> => {
    const requestData: IRequest = {
      endpoint: '/betoneira-configuration/configuration',
      method: HttpMethod.POST,
      body: JSON.stringify({
        devices_configuration: devicesConfiguration.map(toRequestDeviceConfiguration),
      }),
    };
    return this.requester.request(requestData).then((response) => response.data.map(toDeviceConfiguration));
  };
}

export default DeviceConfigurationRequester;
